import React from 'react';
import { useLocation } from 'react-router-dom';

const Demo = () => {
    const location = useLocation();
    const demoLink = location.state?.demoLink;

    return (<div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: "relative",
          width: "70%",
          paddingTop: "39.37%",
        }}
      >
        <iframe
          src={`https://drive.google.com/file/d/${demoLink}/preview`}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "none",
          }}
          allow="autoplay"
          title="Google Drive Video"
        ></iframe>
      </div>
    </div>
    
    );
};

export default Demo;